
import React, {useState, useEffect} from 'react';
import {unmountComponentAtNode} from 'react-dom';
import axios from 'axios';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import ProviderCard from './ProviderCard.jsx';
import ModeSelect from './ModeSelect.jsx';
import ReactGoogleAutocomplete from './ReactGoogleAutocomplete.jsx';
import ReactMap from '../../reactMapBlock/js/ReactMap.jsx';
import ReactDropDown from '../../reactDropDown/js/ReactDropDown.jsx';
import ReactDropDownMulti from '../../reactDropDownMulti/js/ReactDropDownMulti.jsx';
import {locationDropDownProps, sortDropDownProps, timeDropDownProps, serviceDropDownProps, modeProps} from './Mocks.js';

const ReactMakeAppointmentContainerStep2 = (props) => {
	const [providers, setProviders] = useState([]);
	const [googleAutocompleteData, setGoogleAutocompleteData] = useState(props.googleAutocompleteData);
	const [mapCenter, setMapCenter] = useState(props.mapCenter);
	const [markers, setMarkers] = useState([]);

	// filters hooks
	// location and sort are single option drop down select
	// time and service are multi-option drop down select
	const [locationOption, setLocationOption] = useState(locationDropDownProps.options[0]);
	const [sortOption, setSortOption] = useState(sortDropDownProps.options[0]);
	const [timeOptions, setTimeOptions] = useState(timeDropDownProps);
	const [serviceOptions, setServiceOptions] = useState(serviceDropDownProps);
	const [modeFilter, setModeFilter] = useState(modeProps);

	/**
	 *
	 * @param {String} endPoint : api endpoint
	 * @param {Object} options : filter option
	 * @param {func} setData : set response through functionn
	 */
	const getData = (endPoint, options = null, setData) => {
		axios.get(endPoint, options)
		.then((res) => {
			if(res.statusText === 'OK'
				&& res.data
				&& res.data.providers
				&& res.data.providers.length > 0) {
					setProviders(res.data.providers);
					// set google map markers array
					// res.data.providers.map((e, i) => markers.push(e.Geolocation));
					setMarkers(res.data.providers);
			}
		});
	}

	useEffect(() => {
		console.log('step2 props', window.reactMakeAppointmentContainerData);
		console.table(window.reactMakeAppointmentContainerData, );
		const options = {
			params: {
				// sort: sortby
			}
		};
		getData(window.reactMakeAppointmentContainerData.api, options);
	}, [])

	/**
	 * when filters update,
	 * trigger fetch api re-render data
	 */
	useEffect(() => {
		// console.log('locationOption, sortOption, timeOptions, serviceOptions',
		// locationOption,
		// sortOption,
		// timeOptions,
		// serviceOptions);
	}, [
		locationOption,
		sortOption,
		timeOptions,
		serviceOptions
	])
	/**
	 * decode by google autocomplete value
	 * from value to geolocation
	 * set geolocation to map component
	 */
	useEffect(() => {
		if(googleAutocompleteData !== null) {
			console.log(googleAutocompleteData);
			geocodeByAddress(googleAutocompleteData.value.description)
			.then(results => getLatLng(results[0]))
			.then(({ lat, lng }) => {
				console.log('Successfully got latitude and longitude', { lat, lng });
				setMapCenter({lat, lng});
			});
		}
	}, [googleAutocompleteData])

	/**
	 * navigation event
	 * from step 2 to step 1
	 */
	const goPrevious = () => {
		document.getElementById('reactMakeAppointmentContainerStep1').style.display = 'block';
		document.getElementById('reactMakeAppointmentContainer-nav').setAttribute('data-active-index', '1');
		unmountComponentAtNode(document.getElementById('reactMakeAppointmentContainerStep2'));
	};

	/**
	 * navigation event
	 * from step 2 to step 3
	 */
	const goNext = () => {
		document.getElementById('reactMakeAppointmentContainerStep2').style.display = 'none';
		document.getElementById('reactMakeAppointmentContainerStep3').style.display = 'block';
		document.getElementById('reactMakeAppointmentContainer-nav').setAttribute('data-active-index', '3');
	};

	/**
	 *
	 * @param {objedct} selectedProvider
	 * @param {string} selectedTime
	 */
	const onProviderSelect = (selectedProvider, selectedTime) => {
		// set selected the provider & selected time
		window.reactMakeAppointmentContainerData.provider = {
			selectedProvider,
			selectedTime
		};
		console.log(window.reactMakeAppointmentContainerData);
		goNext();
	};

	/**
	 * multi options drop down select call back func
	 * @param {event} event
	 * @param {object} item
	 */
	const handleSelect = (event, item) => {
		let type = item.key;
		let tempProps = type === 'time' ? timeOptions : serviceOptions;
		tempProps.options.map((e, i) => {
			if(e.value === item.value) {
				e.checked = event.target.checked;
			}
			return e;
		});
		let temp = Object.assign({}, tempProps);
		type === 'time'
			? setTimeOptions(temp)
			: setServiceOptions(temp);
	};

	/**
	 * handle mode options select call back func
	 * @param {object} item
	 */
	const handleMode = (item) => {
		modeFilter.options.map((e, i) => {
			if(e.value === item.value) {
				e.checked = !e.checked
			}
			return e;
		});
		let temp = Object.assign({}, modeFilter);
		setModeFilter(temp);
	};

	return (
		<div className="row">
			<div className="col-lg-8">
				<h2>5 providers based on your preferences</h2>
				<ReactGoogleAutocomplete
					value={googleAutocompleteData}
					onChange={setGoogleAutocompleteData}
				/>
				<h3 className="mt-3">Choose provider and appointment time </h3>
				<div className="d-flex mb-2">
					{/* serive multi option drop down */}
					{/* <ReactDropDownMulti
						id="serviceDropDown"
						{...serviceOptions}
						onSelect={handleSelect}
						/> */}
					{/* time of day multi option drop down */}
					<ReactDropDownMulti
						id="timeDropDown"
						{...timeOptions}
						onSelect={handleSelect}
						/>
				</div>
				<div className="mb-2">
					<ModeSelect
						{...modeFilter}
						onSelect={handleMode}
					/>
				</div>
				<div className="d-flex justify-content-between mb-1">
					{/* location single option drop down */}
					<ReactDropDown
						id="locationDropDown"
						activeOption={locationOption}
						{...locationDropDownProps}
						onSelect={setLocationOption}
						/>
					{/* sort single option drop down */}
					<ReactDropDown
						id="sortDropDown"
						activeOption={sortOption}
						{...sortDropDownProps}
						onSelect={setSortOption}
						/>
				</div>
				<div>
					{
						providers.length > 0 &&
						providers.map((e, i) =>
							<ProviderCard {...e} key={i} onProviderSelect={onProviderSelect} />
						)
					}
				</div>
				<button className="btn btn-primary" onClick={() => goPrevious()}>Go Previous</button>
			</div>
			<div className="col-lg-4">
				<div className="embed-responsive embed-responsive-1by1">
					<div className="mapWrapper reactMapBlock">
						<ReactMap
							center={mapCenter}
							markers={markers}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ReactMakeAppointmentContainerStep2;
